interface SweetAlertOptions {
  cancelButtonText: string;
  closeOnConfirm: boolean;
  confirmButtonText: string;
  customClass: string;
  showCancelButton: boolean;
  text: string;
  title: string;
  type: string;
}

interface OptionsArguments {
  closeOnConfirm?: boolean;
  showCancelButton?: boolean;
  thingToDelete?: string;
  thingToRemove?: string;
}

export const deleteOptions = (argument?: OptionsArguments): SweetAlertOptions => ({
  cancelButtonText: bfTranslate("Cancel"),
  closeOnConfirm: argument?.closeOnConfirm ?? true,
  confirmButtonText: bfTranslate("Delete"),
  customClass: 'deleting',
  showCancelButton: argument?.showCancelButton ?? true,
  text: `${bfTranslate("Are you sure you want to delete")} ${argument?.thingToDelete ?? ''}?`,
  title: bfTranslate("Are you sure?"),
  type: "warning",
});

export const removeOptions = (argument?: OptionsArguments): SweetAlertOptions => ({
  cancelButtonText: bfTranslate("Cancel"),
  closeOnConfirm: argument?.closeOnConfirm ?? true,
  confirmButtonText: bfTranslate("Remove"),
  customClass: 'deleting',
  showCancelButton: argument?.showCancelButton ?? true,
  text: `${bfTranslate("Are you sure you want to remove")} ${argument?.thingToRemove ?? ''}?`,
  title: bfTranslate("Are you sure?"),
  type: "warning",
});

export const unsavedChangesOptions = (argument?: OptionsArguments): SweetAlertOptions => ({
  cancelButtonText: bfTranslate("Continue Editing"),
  closeOnConfirm: argument?.closeOnConfirm ?? true,
  confirmButtonText: bfTranslate("Discard and Close"),
  customClass: "unsaved-changes",
  showCancelButton: argument?.showCancelButton ?? true,
  text: bfTranslate("Are you sure you want to discard changes?"),
  title: bfTranslate("Unsaved Changes"),
  type: "warning",
});
